import React, { useEffect } from "react";

import { useUser } from "@components/user-context";
import { logEvent } from "@internal/analytics";

export interface LogOnMountProps<T> {
  readonly name: string;
  readonly data?: T;
  readonly children?: React.ReactNode | React.ReactNode[];
}

export const LogOnMount = <T,>({
  children,
  name,
  data,
}: LogOnMountProps<T>) => {
  const userData = useUser();

  useEffect(() => {
    logEvent(name, {
      ...data,
      isDashboardV2Enabled:
        userData?.user.featureFlags.enableDashboardV2 ?? false,
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [userData]);

  return <>{children}</>;
};
